{
  "name": "admin",
  "version": "1.8.0",
  "private": true,
  "dependencies": {
    "@azure/msal-browser": "catalog:",
    "@equinor/eds-core-react": "^0.31.1",
    "ag-grid-community": "^36.2.0",
    "ag-grid-react": "^36.2.0",
    "bootstrap": "catalog:",
    "moment": "^2.29.4",
    "react": "^18.2.0",
    "react-confirm-alert": "^3.0.6",
    "react-dom": "^18.2.0",
    "react-redux": "^8.0.5",
    "react-router": "^7.18.4",
    "react-select": "^5.7.3",
    "react-toastify": "^9.1.3",
    "redux": "catalog:",
    "redux-devtools-extension": "^2.13.9",
    "redux-saga": "^1.2.3",
    "redux-thunk": "^2.4.2",
    "styled-components": "^5.3.11",
    "typed-redux-saga": "^1.5.0"
  },
  "scripts": {
    "dev": "vite",
    "start": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit"
  },
  "devDependencies": {
    "@testing-library/dom": "catalog:",
    "@testing-library/jest-dom": "catalog:",
    "@testing-library/react": "catalog:",
    "@types/node": "catalog:",
    "@types/react": "^18.2.7",
    "@types/react-dom": "^18.2.4",
    "@vitejs/plugin-react": "catalog:",
    "jsdom": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:"
  }
}
